import React , {useEffect, useRef, useState} from 'react'
import DataTable,  { createTheme  } from 'react-data-table-component';
import Axios from 'axios';
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Modals from './Modals';
import Modals_Load from './Modals_Load';
import { useHistory } from "react-router-dom";

import ReactToPrint from "react-to-print";
import "./istyles.css";
import JsBarcode from 'jsbarcode'; 
import { QRCodeSVG } from 'qrcode.react'; 

import { format, parseISO, isAfter } from 'date-fns';


const FullInvoice = React.forwardRef(({invoice}, ref) => { 
    const {gclang,setgclang} = useContext(AuthContext);
    //const logoSrc = gclang === "th" ? "logo_cubest_th.jpg" : "logo_cubest_en.jpg";
    const logoSrc = gclang === "th" ? "New_CU-Logo2.jpg" : "New_CU-Logo2.jpg";

  return (
    <div ref={ref} style={{ marginLeft: '20px' }}>   
    <br></br>
 
    
    <table  border="0" cellspacing="1" cellpadding="1" style={{"WIDTH": "648px", "HEIGHT": "65px"}}>
							<tr>
								<td rowSpan = "3" style={{"WIDTH": "197px"}}><img height="99" src="./New_CU-Logo.jpg" width="85"/></td>
                <tr>
                
                  <td align="center"><strong>ผลสอบวิชาความถนัดทางธุรกิจ 
                              (CU-BEST)</strong></td>
                </tr>
               

                <tr>
											<td align="center"><strong>Chulalongkorn 
														University - Bussiness Entrance Scholastic Test</strong>
											</td>
								</tr>

                  <tr>
                    <td align="center"><strong>English Program
                         </strong>
                    </td>
                  </tr>

                <tr>
											<td align="center"><strong>Reference:&nbsp;</strong>
												<span>{invoice.CUBEST}</span></td>
								</tr>
								              
                <td align="right">
                <QRCodeSVG       
                        value={`http://cubest.cbs.chula.ac.th/qcheck_hisScore?lang=${invoice.Test_language.toLowerCase()}&ID_Number=${invoice.ID_Number}&CUBEST=${invoice.CUBEST}`} // The text or URL for the QR code
                        size={80} // The size of the QR code
                        bgColor="#ffffff" // Background color
                        fgColor="#000000" // Foreground color
                        level="H" // Error correction level ('L', 'M', 'Q', 'H')
                        includeMargin={true} // Adds a margin around the QR code
                />  
                  
                </td>              
              </tr>


    </table>

<table style={{"WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
							<td align="left">Master of Business Administration</td>
						</tr>
            <tr>
              <td align="left">Faculty of Commerce and</td>
            </tr>                      
            <tr>
              <td align="left">Accountancy, Chulalongkorn University</td>
            </tr>   
            <tr>
              <td align="left">
                Room 506, 50th Memorial Bld.
              </td>
            </tr>
            <tr>
              <td align="left">Phayathai Rd. Bangkok 10330</td>
          </tr>           
          <tr>
              <td align="left">Thailand</td>
          </tr> 
            <tr>
              <td align="left">Tel. (66)-22185717 to 9
              </td>
            </tr>           
            <tr>
              <td align="left">Website:&nbsp;<a href="https://mba.cbs.chula.ac.th/">https://mba.cbs.chula.ac.th/</a></td>
            </tr>

            </table>

<table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
								<td align="right" style={{"width": "129px"}}>Name:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.fullname}</span></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}>Test Date:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.test_date2}</span></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}>Expiry Date:&nbsp;</td>
								<td align="left"><span style={{"width":"320px", fontSize: "16px"}}>{invoice.expiry_date2}</span></td>
						</tr>

            <tr>
                <td align="right" style={{"width": "129px"}}>Test ID:&nbsp;</td>
                <td align="left"><span style={{"width":"320px", fontSize: "18px"}}><b>{invoice.testid}</b></span></td>
            </tr>                   
  </table>
                
  <div style={{ clear: "both" }}></div> {/* Forces tbl3 to a new line */}
  <br></br>

<table cellspacing="1" cellpadding="1" width="648px" align="left" border="1">
	<tr>
		<td align="center">&nbsp;</td>
		<td align="center"><b>Business(200)</b></td>
		<td align="center"><b>Math(200)</b></td>
		<td align="center"><b>Total(400)</b></td>
	</tr>

	<tr>
		<td align="center"><b>Mark</b></td>
		<td align="center"><span style={{"width":"67px"}}>{invoice.MarkSection1}</span></td>
		<td align="center"><span style={{"width":"67px"}}>{invoice.MarkSection2}</span></td>
		<td align="center"><span style={{"width":"67px"}}>{invoice.MarkPoint}</span></td>
	</tr>
</table>

    {/* Watermark 1234567890121*/}
    <div
        style={{
          position: "absolute",
          top: "25%",
          left: "40%",
          transform: "translate(-50%, -50%)",
          opacity: 0.2, // Adjust transparency
          zIndex: 0,
          pointerEvents: "none", // Prevent user interaction
        }}
      >
        <img
          src={logoSrc} // Change to your image path
          alt="Watermark"
          style={{
            width: "500px", // Adjust size
            height: "auto",
          }}
        />
    </div>
   

    {/* http://localhost:3001/qcheck_hisScore?lang=th&ID_Number=1100801172079&CUBEST=2/2567 */}
    {/* <QRCodeSVG       
            value={`http://localhost:3001/qcheck_hisScore?lang=${invoice.Test_language}&ID_Number=${invoice.ID_Number}&CUBEST=${invoice.CUBEST}`} // The text or URL for the QR code
            size={150} // The size of the QR code
            bgColor="#ffffff" // Background color
            fgColor="#000000" // Foreground color
            level="H" // Error correction level ('L', 'M', 'Q', 'H')
            includeMargin={true} // Adds a margin around the QR code
    /> */}
    </div>
 
  );
});


const FrmHisScore_en = () => {
  const fullInvoiceRefs = useRef([]);
      
  const modalsRef = useRef(null);
  const modalsRef_load = useRef(null);
  const history = useHistory();
  
  const {token,settoken} = useContext(AuthContext);

  const [q, setq] = useState("");
  
  const [data,setdata] = useState([]);
    
  const [searchcolumns,setsearchcolumns] = useState(["CUBEST","test_language"]);
    
  const [isedit,setisedit] = useState("0");
  const [pending, setPending] = useState(true);
  const {gclang} = useContext(AuthContext);
  const {gnuserid} = useContext(AuthContext);


  const [Qlang,setQlang] = useState({        
    lang:gclang,
    ID_Number:gnuserid    
  });


  useEffect(() => {
   
    async function fetchData() { 
      
      const response3 = await Axios.post('/qhisscore',Qlang,{               
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
            
      let output3 = response3.data; 
      console.log('tid3',output3);
      
      setPending(false);                  
      setdata(output3);
                                   
      fullInvoiceRefs.current = output3.map((_, i) => fullInvoiceRefs.current[i] || React.createRef());
            
    }
       
    fetchData();  // show data    
         
    },[token]);

  

    const columns = [
      {
        name: 'Ref',
        selector: row => row.CUBEST,
        sortable: true,
        
      },
      {
          name: 'Status',
          selector: row => row.ExpirationStatus,
          sortable: true,
          
      },
      {
        name: 'Expiry Date',
        selector: row => row.expiry_date,
        sortable: true,
        
      },
      {
      name: 'Business',
      selector: row => row.MarkSection1,
      sortable: true,
      
      },
      {
        name: 'Math',
        selector: row => row.MarkSection2,
        sortable: true,
        
      },

      {
        name: 'Total',
        selector: row => row.MarkPoint,
        sortable: true,        
      },
       
         {
           name: "Actions",
           cell: (row, index) => {                
             return (            
               <span>
                 &nbsp;&nbsp;
                 <ReactToPrint
                   trigger={() => (
                     <button>Print Result</button>
                    //  <button disabled={row.ExpirationStatus === 'Expired'}>Print Result</button>
                   )}
                   content={() => fullInvoiceRefs.current[index].current}
                 />&nbsp;&nbsp;
                                                  
                 {/* Hidden Component for Printing */}
                 <div style={{ display: 'none' }}>
                   <FullInvoice ref={fullInvoiceRefs.current[index]} invoice={row} />
                 </div>                
               </span>
             );
           },
           ignoreRowClick: true,
           allowOverflow: true,
           button: true,
         }
     
     
     
  ];

  const customStyles = {
    headRow: {
      style: {
        border: 'none',
      },
    },
    headCells: {
      style: {
        fontSize: '14px',
        fontWeight: '600',
        //textTransform: 'lowercase',        
        color: '#202124',        
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        borderRadius: '25px',
        outline: '1px solid #FFFFFF',
      },
    },
    pagination: {
      style: {
        border: 'none',
      },
    },
  };


function search(rows){
    
  return rows.filter( (row) =>             
    // ค้นหา แบบ ทุก columns
    //columns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)      
    // ค้นหา แบบ กำหนดว่าจะเอา Column ไหนบ้าง
    searchcolumns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)    
  
  );
}



  return (
    <>
      <br></br>      
        <div className="card" style={{width: '100%;'}}>      
        <div className="card-body">
        
          <div className="row mb-3">  
            <h4><i class="fa fa-table" aria-hidden="true"></i>&nbsp;History and Result</h4>
          </div>

                  
          <div class="row">  
            <div class="col-sm-12 my-1">
                <div class="card">
                    <div class="card-body">                                               

                    <DataTable
                            // title="Patient Lists"
                            columns={columns}
                            //data={data}            
                            data={search(data)}
                            //defaultSortField="id"            
                            //defaultSortAsc={true}
                            onRowClicked={ (rowData) => {              
                            console.log(rowData.id);
                            }}   
                            // selectableRows                             
                            pagination 
                            fixedHeader            
                            fixedHeaderScrollHeight="2000px"                            
                            highlightOnHover
                            pointerOnHover            
                            striped
                            responsive                     
                            customStyles={customStyles}
                            progressPending={pending}
                            paginationRowsPerPageOptions={[10,25,50,100,1000000]}
                                                
                        />
                       
                       
                    </div>
                </div>
            </div>
          </div>       
  

    </div>
    </div>
    </>      
  )
}


export default FrmHisScore_en